<template>
  <ModalDialog
    header-text="Thank you for your submission"
    @closeModal="closeModal"
    open
  >
    <template v-slot:content>
      <div class="inspection__results">
        <p>Please reference the following TripID for tracking purposes:</p>
        <p class="inspection__results-label">
          {{ tripId }}
        </p>
        <div v-if="failedAttachments.length > 0">
          <p>
            Your Trip Report has been successfully submitted. However the
            following attachment(s) were not properly uploaded:
          </p>
          <ul>
            <li v-for="attachment in failedAttachments" :key="attachment">
              {{ attachment }}
            </li>
          </ul>
          <p>
            Please resend failed EFR attachments to Accounting via mail or email
            to
            <a :href="attachementsEmailLink"> failed.efr.attachments@ou.org </a
            >. Please make sure to include your name and the Trip ID in the
            subject line of the email.
          </p>
        </div>
        <p>
          A record of your financial submission can be viewed in the EFR
          Electronic Financial Report History.
        </p>
        <Button type="button" themeColor="secondary" @click="closeModal"
          >Return to My Trip Reports</Button
        >
      </div>
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import ModalDialog from "@/shared/ui/modal/ModalDialog.vue";
import { useMainStore } from "@/stores/useMainStore";
import { Button } from "@progress/kendo-vue-buttons";
import { computed } from "vue";

const main = useMainStore();

const emit = defineEmits<{
  (e: "closeModal"): void;
}>();

const props = defineProps<{
  tripId: number;
  failedAttachments: string[];
}>();

const attachementsEmailLink = computed(() => {
  return `mailto:failed.efr.attachments@ou.org?subject=EFR Expense attachments from ${main.userLogin} for Trip ID ${props.tripId}.`;
});

const closeModal = function () {
  emit("closeModal");
};
</script>

<style lang="scss">
.inspection__results {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-bottom: 12px;

  &-label {
    font-size: 24px;
    font-weight: bold;
  }
}
</style>
